import React from "react";
import '../../style/css/ModulesDashboard.css'; 
import { Link } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useSelector } from "react-redux";


const ModulesDashboard = () => {
  const route = all_routes;
  const user = useSelector((state) => state.auth.user);


    return (
        <div className="modules-dashboard main-wrapper">
            <div className="dashboard-header">
                <h2 className="text-center">Bienvenue, {user.name} !</h2>

            </div>

            {/* Grille des modules */}
            <div className="modules-grid">
                
                <Link to={route.salesdashboard} className="btn btn-login">
                    <div  className="module-card">
                        <div className="module-icon">📊</div>
                        <h2 className="module-name">Tableau de bord</h2>
                    </div>                    
                </Link>

                <Link to={route.restaurant} className="btn btn-login">
                    <div  className="module-card">
                        <div className="module-icon">🍽️</div>
                        <h2 className="module-name">Serveur</h2>
                    </div>                    
                </Link>

                <Link to={route.stockmove} className="btn btn-login">
                    <div  className="module-card">
                        <div className="module-icon">👨🏽‍🍳🍻</div>
                        <h2 className="module-name">Cuisine / Bar</h2>
                    </div>                    
                </Link>

                <Link to={route.productlist} className="btn btn-login">
                    <div  className="module-card">
                        <div className="module-icon">📦</div>
                        <h2 className="module-name">Stock</h2>
                    </div>                    
                </Link>

                <Link to={route.employees} className="btn btn-login">
                    <div  className="module-card">
                        <div className="module-icon">👥</div>
                        <h2 className="module-name">RH</h2>
                    </div>                    
                </Link>
     
            </div>
            
        </div>
    );
};

export default ModulesDashboard;
